"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateModuleDocumentRequirement = exports.StateModules = exports.REQUIRED_ACKNOWLEDGEMENT_NOT_CHECKED = exports.STATE_OVERRIDE_TYPES = exports.REQUIRED_STATE_MODULES_BEFORE_PRE_QUAL_ACCEPTED = exports.StateModulesSlotName = void 0;
var StateModulesSlotName;
(function (StateModulesSlotName) {
    StateModulesSlotName["PersonalInfo"] = "PersonalInfo";
    StateModulesSlotName["PreQualFooter"] = "PreQualFooter";
    StateModulesSlotName["WelcomeScreen"] = "WelcomeScreen";
    StateModulesSlotName["StatedIncome"] = "StatedIncome";
    StateModulesSlotName["StatedIncomeApplicant"] = "StatedIncomeApplicant";
    StateModulesSlotName["StatedIncomeCoApplicant"] = "StatedIncomeCoApplicant";
    StateModulesSlotName["StatedIncomeFooter"] = "StatedIncomeFooter";
    StateModulesSlotName["OfferFooter"] = "OfferFooter";
    StateModulesSlotName["OfferCTA"] = "OfferCTA";
    StateModulesSlotName["ApplicantConfirmPii"] = "ApplicantConfirmPii";
    StateModulesSlotName["PreNotarizationPage"] = "PreNotarizationPage";
    StateModulesSlotName["PreNotarizationPageFooter"] = "PreNotarizationPageFooter";
    StateModulesSlotName["EstimatedClosingCosts"] = "EstimatedClosingCosts";
})(StateModulesSlotName || (exports.StateModulesSlotName = StateModulesSlotName = {}));
/**
 * !!!IMPORTANT!!!
 * If you add a new slot name w/ value true, you must add a StateFormModule component for it on PostPreQualStateModulesAndMaritalStatus.vue
 */
// Todo Is there a better way to enforce that PostPreQualStateModulesAndMaritalStatus.vue has all needed slots?
const SLOT_NAME_REQUIRED_BEFORE_PRE_QUAL_ACCEPTED = {
    [StateModulesSlotName.PersonalInfo]: true,
    [StateModulesSlotName.StatedIncome]: true,
    [StateModulesSlotName.StatedIncomeFooter]: true,
    [StateModulesSlotName.StatedIncomeApplicant]: true,
    [StateModulesSlotName.StatedIncomeCoApplicant]: true,
    [StateModulesSlotName.PreQualFooter]: false,
    [StateModulesSlotName.WelcomeScreen]: false,
    [StateModulesSlotName.OfferFooter]: false,
    [StateModulesSlotName.OfferCTA]: false,
    [StateModulesSlotName.ApplicantConfirmPii]: false,
    [StateModulesSlotName.PreNotarizationPage]: false,
    [StateModulesSlotName.PreNotarizationPageFooter]: false,
    [StateModulesSlotName.EstimatedClosingCosts]: false,
};
exports.REQUIRED_STATE_MODULES_BEFORE_PRE_QUAL_ACCEPTED = Object.keys(SLOT_NAME_REQUIRED_BEFORE_PRE_QUAL_ACCEPTED).filter((slotName) => {
    return SLOT_NAME_REQUIRED_BEFORE_PRE_QUAL_ACCEPTED[slotName];
});
// This is a dummy object to get TS to force the keys of StateOverrideType to be properly typed and ensure type safety
const StateOverrideTypeDummyObj = {
    supported: true,
    trustSupported: true,
    isCommunityPropertyState: true,
    isTaxState: true,
    isRinNotarizationSupported: true,
    isAttorneyState: true,
    isRestrictedLineSizeState: true,
    isMegaLineSupported: true,
    isTitleInsuranceExemptState: true,
    requiresWitness: true,
    titleOfficeClosing: true,
    requiresOutOfBandClosingPackage: true,
    schedulingStartOffsetDays: null,
};
exports.STATE_OVERRIDE_TYPES = Object.keys(StateOverrideTypeDummyObj);
// The 400 error for a required acknowledgement sent unchecked; the frontend asks the applicant to refresh
exports.REQUIRED_ACKNOWLEDGEMENT_NOT_CHECKED = 'REQUIRED_ACKNOWLEDGEMENT_NOT_CHECKED';
var StateModules;
(function (StateModules) {
    /**
     * Shows a link to the document along with a mandatory checkbox and optionally a
     * subtitle
     */
    StateModules["RequiredDocumentAck"] = "RequiredDocumentAck";
    /**
     * Shows a link to a set of documents anda single link to download them all, along with a mandatory checkbox and optionally a
     * subtitle for the whole block
     */
    StateModules["MultipleRequiredDocumentAck"] = "MultipleRequiredDocumentAck";
    /**
     * Shows a link to the document and optionally a subtitle
     */
    StateModules["DocumentDisclosure"] = "DocumentDisclosure";
    /**
     * Required document that needs to be signed electronically; Similar to MultipleRequiredDocumentAck but
     * will show a signing box in the FE for e-signature instead of a checkbox
     */
    StateModules["MultipleRequiredDocumentEsign"] = "MultipleRequiredDocumentEsign";
    /**
     * Just shows some text, to be used on welcome screen
     */
    StateModules["WelcomeExtraInfo"] = "WelcomeExtraInfo";
    /**
     * Just shows text, to be used on the footer section of any page
     */
    StateModules["FooterDisclosure"] = "FooterDisclosure";
    /**
     * Shows a disclosure text under the continue button
     */
    StateModules["ContinueDisclosure"] = "ContinueDisclosure";
    /**
     * Shows a set of inputs to collect attorney and insurance preference information for SC loans
     */
    StateModules["AttorneyInsurancePreference"] = "AttorneyInsurancePreference";
})(StateModules || (exports.StateModules = StateModules = {}));
/**
 * What the applicant must do with a document shown in a state module before the page can be skipped.
 */
var StateModuleDocumentRequirement;
(function (StateModuleDocumentRequirement) {
    /** Checkbox, e-signature or form submission that moves the document ack to acknowledged/signed */
    StateModuleDocumentRequirement["acknowledge"] = "acknowledge";
    /** Link only; showing it once is enough, so no ack is recorded */
    StateModuleDocumentRequirement["view"] = "view";
    /** The applicant never has to act on the document */
    StateModuleDocumentRequirement["none"] = "none";
})(StateModuleDocumentRequirement || (exports.StateModuleDocumentRequirement = StateModuleDocumentRequirement = {}));
